export default "__VITE_ASSET__BMYt$0Cw__"